// src/environments/environment.ts
export const environment = {
  production: false,
  emailjs: {
    publicKey: 'gaJoiJZ6wfDXH_j98',
    serviceId: 'service_282gzqg',
    templateId: 'template_hq9mj15'
  },
  congressApiKey: 'ZA65tdiQNMhaKBeV4XkhR7cINdBlTTdH2yAUkbkK',
   baseUrl: 'https://www.lydialynnchristensen.com' // Use production URL even locally for sharing
};

